import React from "react";
import "./prominentDepositores.css";

import ONGC from "../assets/partners/1.jpeg";
import TTESC from "../assets/partners/2.jpeg";
import AAVIN from "../assets/partners/3.jpeg";
import LIC from "../assets/partners/4.jpeg";
import FACT from "../assets/partners/5.jpeg";
import IFFCO from "../assets/partners/6.jpeg";
import LUGT from "../assets/partners/7.jpeg";
import AIDS from "../assets/partners/8.jpeg";
import TASMAC from "../assets/partners/9.jpeg";
import FCI from "../assets/partners/10.jpeg";
import NAFED from "../assets/partners/11.jpeg";
import TANFED from "../assets/partners/12.jpeg";
import TPNV from "../assets/partners/13.jpeg";
import { useTranslation } from "react-i18next";

// import tnpl from "../assets/PD1.jpg";

function ProminentDepositors() {

  const { t } = useTranslation();
  const logos = [
    { name: "ONGC", image: ONGC },
    { name: "TNTBC", image: TTESC },
    { name: "AAVIN", image: AAVIN },
    { name: "LIC", image: LIC },
    { name: "FACT", image: FACT },
    { name: "IFFCO", image: IFFCO },
    { name: "RCF", image: LUGT },
    { name: "TANSACS", image: AIDS },
    { name: "FCI", image: FCI },
    { name: "NAFED", image: NAFED },
    { name: "TANFED", image: TANFED },
    { name: "TNCSC", image: TPNV },
    { name: "TASMAC", image: TASMAC },

    // { name: "TNPL", image: tnpl },

  ];

  return (
    <section className="prominent-depositors py-5 bg-light">
      <div className="container-fluid">
        <h3 className="text-center fw-bold mb-4">
          {t("prominentdepositors")}
        </h3>

        <div className="logo-slider">
          <div className="logo-track">
            {/* First set */}
            {logos.map((logo, index) => (
              <div className="logo-item" key={`first-${index}`}>
                <img
                  src={logo.image}
                  alt={logo.name}
                />
                <div className="logo-name">
                  {logo.name}
                </div>
              </div>
            ))}

            {/* Duplicate set for continuous scrolling */}
            {logos.map((logo, index) => (
              <div className="logo-item" key={`second-${index}`}>
                <img
                  src={logo.image}
                  alt={logo.name}
                />
                <div className="logo-name">
                  {logo.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProminentDepositors;